const theme = {
    sr: 'sr',
    ue: 'ue',
    bruno: 'bruno',
    sample: 'sample',
    softrig: 'softrig',
    default: 'ue'
}

export default theme;